import { useSearchBar } from '../hooks/useSearchBar';

import Icon from '../../../icons/Icon';

const SearchBarIcon = () => {
	const { blockClass } = useSearchBar();

	return (
		<button
			className={`searchBarIcon searchBarIcon--${blockClass} vtex-store-components-3-x-searchBarIcon ${blockClass ? 'vtex-store-components-3-x-searchBarIcon--' + blockClass : ''} vtex-store-components-3-x-searchBarIcon--search vtex-store-components-3-x-searchBarIcon--${blockClass}--search flex items-center pointer bn bg-transparent outline-0 pv0 pl0 pr3`}
		>
			<Icon
				id="hpa-search"
				handle={`vtex-store-components-3-x-searchIcon searchIcon  vtex-store-components-3-x-searchIcon--${blockClass} searchIcon--${blockClass}`}
			/>
		</button>
	);
};

export default SearchBarIcon;
